import { useTranslation } from "react-i18next";
import { languages } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

/** `triggerClassName` restyles the button (e.g. for a light header); the default suits the dark site header.
 *  `rowLabel` (with `triggerClassName`) makes the button a text-only menu row: the label, then the current
 *  language's name, no icon (the new site's phone menu). */
const LanguageSelector = ({ triggerClassName, rowLabel }: { triggerClassName?: string; rowLabel?: string } = {}) => {
  const { i18n } = useTranslation();
  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
    <DropdownMenu>
      {triggerClassName && rowLabel ? (
        <DropdownMenuTrigger aria-label={`Language: ${currentLang.label}`} className={triggerClassName}>
          <span>{rowLabel}</span>
          <span className="text-muted-foreground">{currentLang.label}</span>
        </DropdownMenuTrigger>
      ) : triggerClassName ? (
        <DropdownMenuTrigger aria-label={`Language: ${currentLang.label}`} className={triggerClassName}>
          <Globe className="h-4 w-4" aria-hidden="true" />
          <span>{currentLang.code.toUpperCase()}</span>
        </DropdownMenuTrigger>
      ) : (
        <DropdownMenuTrigger className="flex items-center gap-1.5 px-2 py-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors text-sm">
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{currentLang.flag}</span>
        </DropdownMenuTrigger>
      )}
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            className={`gap-2 cursor-pointer ${i18n.language === lang.code ? "bg-accent" : ""}`}
          >
            <span>{lang.flag}</span>
            <span>{lang.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
